import { Button, Modal } from 'semantic-ui-react';
import { GroupRowColumns } from 'src/components/common/rows/GroupRow';
import styled from '@emotion/styled';
import AGTable from 'src/components/table/aggrid';
import { useRef, useEffect } from 'react';
import { useMemo } from 'react';

const PendMemTableComponent = styled('div')`
  @media only screen and (max-width: 600px) {
    padding: 0;
    .date {
      display: none;
    }
  }
`;

const PendingNewMembers = (props) => {
  const { setOpen, isCouples, getInfo, pendingMembers } = props;
  const gridRef = useRef(null);

  useEffect(() => {
    if (gridRef.current) {
      gridRef?.current?.api?.sizeColumnsToFit();
    }
  }, [pendingMembers]);

  const columnDefs = useMemo(
    () =>
      GroupRowColumns({
        isCouples,
        getInfo,
        isPendingNewMembers: true,
      }),
    [isCouples, getInfo]
  );

  return (
    <Modal onClose={() => setOpen(false)} onOpen={() => setOpen(true)} open>
      <Modal.Header>Personas interesadas en entrar</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <PendMemTableComponent>
            {pendingMembers.length ? (
              <AGTable
                rowData={pendingMembers}
                rowHeight={50}
                suppressDragLeaveHidesColumns={false}
                columnDefs={columnDefs}
                tableRef={gridRef}
              />
            ) : (
              <p>No tienes más personas pendientes</p>
            )}
          </PendMemTableComponent>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)}>Cerrar</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default PendingNewMembers;
